"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsSortOrder = void 0;
var SearchResultsSortOrder;
(function (SearchResultsSortOrder) {
    SearchResultsSortOrder["Popularity"] = "popularity";
    SearchResultsSortOrder["Recency"] = "recency";
})(SearchResultsSortOrder = exports.SearchResultsSortOrder || (exports.SearchResultsSortOrder = {}));
exports.default = { SearchResultsSortOrder: SearchResultsSortOrder };
